import { render, staticRenderFns } from "./sapf.vue?vue&type=template&id=f78dd330&scoped=true&"
import script from "./sapf.vue?vue&type=script&lang=js&"
export * from "./sapf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f78dd330",
  null
  
)

export default component.exports